'use strict';
const angular = require('angular');

/**
 * Signature component.
 * This module will initialize the Signature component for angular application.
 * @module Stepper
 */

export class StepperComponent {
    currentStep:any;
    $translate: any;

    data = [{
        'title': 'Basic Information',
        'step': 1
      }, {
        'title': 'Filters',
        'step': 2
      }, {
        'title': 'Response',
        'step': 3
      }];

    constructor($element,$translate) {
        this.$translate=$translate;
    }
    $onChanges(changes) {
        if (changes.currentStep && changes.currentStep.currentValue) {
            this.currentStep = parseInt(changes.currentStep.currentValue);
        }
      }

}  

export default angular.module('directives.stepper', [])
.component('stepper', {
    template: require('./stepper.html'),
    controller: StepperComponent,
    // scope:{},
    bindings: {
       currentStep:'@',
       updateparent: '&',
       stepClick: '&stepClick'
    }
    
}).name;



// WEBPACK FOOTER //
// ./client/components/stepper/stepper.component.ts